import * as React from "react";
import * as ReactDOM from "react-dom";
import { RuntimeConnectedShadeUtils } from "../../Utils/RuntimeConnectedShadeUtils";

export interface RuntimeConnectedShadeProps extends React.Props<RuntimeConnectedShadeState> {
  visibilityChange?: (visible: boolean) => any;
}

export interface RuntimeConnectedShadeState {
  visible: boolean;
}

export class RuntimeConnectedShade extends React.Component<RuntimeConnectedShadeProps, RuntimeConnectedShadeState> {
  constructor(props: RuntimeConnectedShadeProps) {
    super(props);
    this.state = {
      visible: false
    };

    RuntimeConnectedShadeUtils.initialize();
  }

  componentWillMount() {
    RuntimeConnectedShadeUtils.on(RuntimeConnectedShadeUtils.ModalVisibleEventName, this.onChildMessage);
  }

  componentWillUnmount() {
    RuntimeConnectedShadeUtils.off(RuntimeConnectedShadeUtils.ModalVisibleEventName, this.onChildMessage);
  }

  onChildMessage = (e: JQueryEventObject, visibleData: any) => {
    console.log(visibleData, e);
    this.setState({
      visible: visibleData && visibleData.visibility
    });
  }

  render(): JSX.Element {
    if (!this.state.visible) {
      return null;
    }

    return <div className="cover-shade"></div>;
  }
}



// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/v4/RuntimeConnectedShade.tsx